'use client'
import GoldLinkButton from '@/components/GoldLinkButton'
import TextWithLineBreaks from '@/components/TextWithlineBreak'
import { useLocale, useTranslations } from 'next-intl'
import Image from 'next/image'
import { useIpLocation } from 'src/lib/api/homeService'
import parisImg from 'images/Hero-PARIS-RGB.jpg'
import miamiImg from 'images/ROLZO MIAMI RGB.webp'
import mexicoImg from 'images/Hero-MEXICO-RGB.jpg'
import newYorkImg from 'images/Hero-NY-RGB.webp'
import londonImg from 'images/Hero-LONDON-RGB.webp'
import defaultDubaiImg from 'images/homepageimg.webp'
const WhyRolzoBth = () => {
  const t = useTranslations('BTHpage')
  const { ipData, error, isLoading } = useIpLocation()
  const locale = useLocale()
  const getCityImageUrl = (ipLocation, localeId) => {
    let url = ''

    if (ipLocation === 'US-Miami') {
      url = miamiImg
    } else if (localeId === 'es' || ipLocation === 'MX') {
      url = mexicoImg
    } else if (localeId === 'fr' || ipLocation === 'FR') {
      url = parisImg
    } else if (ipLocation === 'US' && localeId !== 'fr' && localeId !== 'es') {
      url = newYorkImg
    } else if (ipLocation === 'GB' && localeId !== 'fr' && localeId !== 'es') {
      url = londonImg
    } else if (
      ipLocation !== 'GB' &&
      ipLocation !== 'FR' &&
      ipLocation !== 'MX' &&
      localeId !== 'fr' &&
      ipLocation !== 'US' &&
      localeId !== 'es' &&
      ipLocation !== 'US-Miami'
    ) {
      url = defaultDubaiImg
    }
    return url
  }
  return (
    <>
      <section className='pt-12    pb-12'>
        <div className='container md:px-0'>
          <div className='grid grid-cols-1 relative md:grid-cols-12 items-center'>
            <div className='col-span-6 md:px-[80px] md:mb-12 order-2 md:order-1'>
              <TextWithLineBreaks
                t={t}
                element='h5'
                elementClassName='text-[28px]  mb-6 font-light leading-[1.4]'
                textKey='otherSections.Everything about it is effortless'
                lineBreakClassname='hidden xl:block'
              />
              <TextWithLineBreaks
                t={t}
                element='p'
                elementClassName='leading-[1.6] text-[18px] text-rolzo-black md:text-[16px] font-light mb-6'
                textKey='otherSections.Everything about it is effortless-desc'
                lineBreakClassname='hidden xl:block'
              />
            </div>
            <div className='col-span-6 md:px-[15px] mb-8 md:mb-0 order-1 md:order-2'>
              <Image
                src={getCityImageUrl(ipData, locale)}
                alt=''
                width={540}
                height={381}
                className='w-[540px] h-auto max-w-full max-h-full'
                priority={true}
                quality={90}
              />
            </div>
          </div>
        </div>
      </section>
      <section className='py-12'>
        <div className='container md:px-0'>
          <div className='grid grid-cols-1 relative md:grid-cols-12 items-center'>
            <div className='col-span-6 md:px-[80px] md:mb-12 order-2 md:order-2'>
              <TextWithLineBreaks
                t={t}
                element='h5'
                elementClassName='text-[28px]  mb-6 font-light leading-[1.4]'
                textKey='otherSections.Business-class comfort'
                lineBreakClassname='hidden xl:block'
              />
              <TextWithLineBreaks
                t={t}
                element='p'
                elementClassName='leading-[1.6] text-[18px] text-rolzo-black md:text-[16px] font-light mb-6'
                textKey='otherSections.Business-class comfort-desc'
                lineBreakClassname='hidden xl:block'
              />
            </div>
            <div className='col-span-6 md:px-[15px] mb-8 md:mb-0 order-1 md:order-1'>
              <Image
                src='https://storage.googleapis.com/rolzo-static-bucket/illustration-small/1-fleet-chauffeur-first.jpg'
                alt=''
                width={540}
                height={381}
                className='w-[540px] h-auto max-w-full max-h-full object-contain'
                priority={true}
              />
            </div>
          </div>
        </div>
      </section>
      <section className='py-12'>
        <div className='container md:px-0'>
          <div className='grid grid-cols-1 relative md:grid-cols-12 items-center mb-12 md:mb-0'>
            <div className='col-span-6 md:px-[80px] md:mb-12 order-2 md:order-1'>
              <TextWithLineBreaks
                t={t}
                element='h5'
                elementClassName='text-[28px]  mb-6 font-light leading-[1.4]'
                textKey='otherSections.A chauffeur that feels like a butler'
                lineBreakClassname='hidden xl:block'
              />
              <TextWithLineBreaks
                t={t}
                element='p'
                elementClassName='leading-[1.6] text-[18px] text-rolzo-black md:text-[16px] font-light mb-6'
                textKey='otherSections.A chauffeur that feels like a butler-desc'
                lineBreakClassname='hidden xl:block'
              />
            </div>
            <div className='col-span-6 md:px-[15px] mb-8 md:mb-0 order-1 md:order-2'>
              <Image
                src='https://storage.googleapis.com/rolzo-static-bucket/illustration-small/chauffeur-services.jpg'
                alt=''
                width={427}
                height={300}
                className='size-auto'
                priority={true}
              />
            </div>
          </div>
          <div className='flex items-center md:justify-center'>
            <GoldLinkButton
              isNewTab
              href='https://business.rolzo.com/auth/login'
              hasGoldBackground
              text='Book now'
            />
          </div>
        </div>
      </section>
    </>
  )
}

export default WhyRolzoBth
